/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagBaselineDefinitionVersion extends models.BaseDefinitionVersion {
    getFixupPrototypeFunction() { return TagBaselineDefinitionVersion.fixupPrototype; }

    static newInstance(model: Partial<TagBaselineDefinitionVersion>): TagBaselineDefinitionVersion {
        let obj = Object.assign(new TagBaselineDefinitionVersion(), model);
        TagBaselineDefinitionVersion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagBaselineDefinitionVersion>): TagBaselineDefinitionVersion {
        if (!model) return null;
        return TagBaselineDefinitionVersion.newInstance(<TagBaselineDefinitionVersion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagBaselineDefinitionVersion) {
        if (!obj) return;

        models.TagBaselineDefinitionVersion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagBaselineDefinitionVersion): boolean {
        if (models.BaseDefinitionVersion.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TagBaselineDefinitionVersion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.details) {
            models.TagBaselineConfiguration.fixupPrototype(this.details);
        }
    }

    /**
     * Details of the version
     */
    details: models.TagBaselineConfiguration;

}
